import { Avatar as Avatars } from 'primereact/avatar';  

const Avatar = ({...rest}) => {

    return (
        <Avatars {...rest} />
    )

};

export default Avatar;